import { Component, OnInit } from '@angular/core';
import { EditorService } from '../../editor.service';
@Component({
  selector: 'app-drawingcardcolor',
  templateUrl: './drawingcardcolor.component.html',
  styleUrls: ['./drawingcardcolor.component.css']
})
export class DrawingcardcolorComponent implements OnInit {

  constructor(private editorService: EditorService) { }

  ngOnInit() {
  }

  changeDrawingColour(color) {
    let com = this.editorService.getIframeReference();
    com.changeDrawingColour(color);

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/drawingcardcolor/drawingcardcolor.component.ts